import dayjs   from "dayjs";
import fromNow from "dayjs/plugin/relativeTime";
import utc     from "dayjs/plugin/utc";
import React   from "react";

import { shortenNumber } from "_common/utils";
import Typography        from "_components/atoms/typography";
import useStyles         from "_styles/atoms/broadcastTitle";

const component = props => {
	const {
		sessionData, totalComments = 0, totalLikes = 0, endTimeUTC, views = 0, totalViews = 0, startedTimeUTC
	} = props;

	if ( !sessionData )
		return null;

	const { classes } = useStyles ( undefined, { name: "styles" } );

	dayjs.extend ( utc );
	dayjs.extend ( fromNow );

	return (
		<div className = { classes.titlecontainer }>
			<Typography
				className = { classes.titleBroadcast }
				size      = "lg"
				title     = { sessionData }
				weight    = { 500 }
			/>

			<div className = { classes.statsContainer }>
				{endTimeUTC && (
					<div className = { classes.statsContainer }>
						<Typography
							className = { classes.statsText }
							color     = "secondary"
							size      = "sm"
							title     = { `${ dayjs ( dayjs.utc ( endTimeUTC ) ).fromNow () }` }
						/>

						{views !== 0 && <div className = { classes.ellipsis } />}
					</div>

				)}

				{startedTimeUTC && (
					<div className = { classes.statsContainer }>
						<Typography
							className = { classes.statsText }
							color     = "secondary"
							size      = "sm"
							title     = { `${ dayjs ( dayjs.utc ( startedTimeUTC ) ).fromNow () }` }
						/>

						<div className = { classes.ellipsis } />
					</div>

				)}

				{/* For ended live streams  */}
				{totalViews !== 0 && (
					<div className = { classes.statsContainer }>
						<Typography
							className = { classes.statsText }
							color     = "secondary"
							size      = "sm"
							title     = { `${ shortenNumber ( totalViews ) } Views` }
						/>

						<div className = { classes.ellipsis } />

					</div>
				)}

				{/* Case for Videos, Don't send Views for Broadcast */}

				{views !== 0 && (
					<div className = { classes.statsContainer }>
						<Typography
							className = { classes.statsText }
							color     = "secondary"
							size      = "sm"
							title     = { `${ shortenNumber ( views ) } Views` }
						/>

					</div>
				)}

				{/* Case for Videos, Don't send Likes for Broadcast */}

				{totalLikes !== 0 && (
					<div className = { classes.statsContainer }>
						<Typography
							className = { classes.statsText }
							color     = "secondary"
							size      = "sm"
							title     = { `${ shortenNumber ( totalLikes ) } Likes` }
						/>

						<div className = { classes.ellipsis } />
					</div>
				)}

				{totalComments !== 0 && (
					<div className = { classes.statsContainer }>
						<Typography
							className = { classes.statsText }
							color     = "secondary"
							size      = "sm"
							title     = { `${ shortenNumber ( totalComments ) } Comments` }
						/>

					</div>
				)}

			</div>
		</div>
	);
};

export default component;
